export const initPrimaryTabUtil = () => {
  let _isPrimary = false;
  return {
    setIsPrimary: isPrimary => {
      _isPrimary = isPrimary;
    },
    get isPrimary() {
      return _isPrimary;
    }
  };
};

/**
 * Get the singleton instance of the primary tab util, initialized on first call
 */
let instance = null;
export const getPrimaryTabUtil = () => {
  if (!instance) {
    instance = initPrimaryTabUtil();
  }
  return instance;
};